import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import OfflineTooltip from 'components/OfflineTooltip';
import UnavailablesFullDatePicker from 'components/UnavailablesFullDatePicker';
import EmployeeActions from 'actions/EmployeeActions';
import UnavailableSidebarItem from 'components/UnavailableSidebarItem.js';
import UnavailablesPartialDatePicker from 'components/UnavailablesPartialDatePicker';
import UnavailablesPartialFullDatePicker from 'components/UnavailablesPartialFullDatePicker.js';
import Popover from 'components/popover/Popover.js';
import NaApi from 'utils/NaApi';
import { describeUnavailable, confirmRemoveNa } from 'components/ScheduleSidebar/unavailableRows.js';

class SidebarTimeOff extends React.Component {
  constructor(props) {
    super(props);

    this.onSuccessfulCreate = this.onSuccessfulCreate.bind(this);
    this.onCreateError = this.onCreateError.bind(this);
    this.onTimeoffClick = this.onTimeoffClick.bind(this);
    this._onClosePopover = this._onClosePopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this.onPostTimeoff = this.onPostTimeoff.bind(this);
    this.onTextAreaInput = this.onTextAreaInput.bind(this);
    this.onUnavailTypeSelect = this.onUnavailTypeSelect.bind(this);
    this.datePicker = this.datePicker.bind(this);
    this.onDeclaringDeptChange = this.onDeclaringDeptChange.bind(this);
    this.onDeclareNa = this.onDeclareNa.bind(this);
    this.onRemoveNa = this.onRemoveNa.bind(this);
    this.onNaCreateSuccess = this.onNaCreateSuccess.bind(this);
    this.onNaCreateError = this.onNaCreateError.bind(this);
    this.onNaRemoveSuccess = this.onNaRemoveSuccess.bind(this);
    this.onNaRemoveError = this.onNaRemoveError.bind(this);
    this.startPicker = null;
    this.endPicker = null;

    this.state = {
      popOverActive: false,
      popTarget: null,
      partial: this.initialPartialState(),
      startsAt: null,
      endsAt: null,
      notes: '',
      unavailableTypeId: this.initialUnavailableType(),
      requestError: false,
      declaringDepartmentId: this.initialDeclaringDept(),
      naAvailability: null,
      naError: '',
      naListError: '',
    };
  }

  // Generic state updater called from children
  // components
  updateStateHandler(name, value) {
    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    const that = this;

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);

    UnavailablesStore.on('unavailables:create:success', this.onSuccessfulCreate);
    UnavailablesStore.on('unavailables:create:error', this.onCreateError);
    UnavailablesStore.on('unavailables:na:create:success', this.onNaCreateSuccess);
    UnavailablesStore.on('unavailables:na:create:error', this.onNaCreateError);
    UnavailablesStore.on('unavailables:na:remove:success', this.onNaRemoveSuccess);
    UnavailablesStore.on('unavailables:na:remove:error', this.onNaRemoveError);
  }

  componentWillUnmount() {
    UnavailablesStore.off('unavailables:create:success', this.onSuccessfulCreate);
    UnavailablesStore.off('unavailables:create:error', this.onCreateError);
    UnavailablesStore.off('unavailables:na:create:success', this.onNaCreateSuccess);
    UnavailablesStore.off('unavailables:na:create:error', this.onNaCreateError);
    UnavailablesStore.off('unavailables:na:remove:success', this.onNaRemoveSuccess);
    UnavailablesStore.off('unavailables:na:remove:error', this.onNaRemoveError);

    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  _onClosePopover() {
    this.setState({
      popOverActive: false,
      popTarget: null,
      startsAt: null,
      endsAt: null,
      notes: '',
      unavailableTypeId: this.initialUnavailableType(),
      partial: this.initialPartialState(),
      declaringDepartmentId: this.initialDeclaringDept(),
      naAvailability: null,
      naError: '',
    });
  }

  resetPopover() {
    const buttons = document.querySelectorAll('.btn-group button');

    [].forEach.call(buttons, (button) => {
      button.removeAttribute('disabled');
    });

    const el = document.querySelector('.popovertimeoff');
    const errors = el.querySelectorAll('.error');
    [].forEach.call(errors, (error) => {
      error.classList.remove('error');
    });

    if (!Utils.isNotDefined(this.startPicker)) this.startPicker.setDate(this.props.selectedDate);
    if (!Utils.isNotDefined(this.endPicker)) this.endPicker.setDate(this.props.selectedDate);

    el.removeAttribute('data-shift-replied');

    // The N/A form renders its own status span instead of span.error-message,
    // so this can be absent while an N/A type is selected.
    const errorField = document.querySelector('span.error-message');
    if (errorField) errorField.innerHTML = '';
    this.setState({
      requestError: false
    })
  }

  onCreateError(response) {
    const errorField = ReactDOM.findDOMNode(this).querySelector('span.error-message');
    errorField.innerHTML = JSON.parse(response.responseText).error_message;
    errorField.parentNode.classList.add('error');
    this.setState({
      requestError: true
    })
  }

  onSuccessfulCreate(collection, id) {
    this.resetPopover();
    this._onClosePopover();
  }

  onTextAreaInput(e) {
    this.setState({ notes: e.target.value });
  }

  onUnavailTypeSelect(e) {
    const unavailableTypeId = parseInt(e.target.value);
    this.setState({ unavailableTypeId, naError: '' }, () => {
      // Switching to (or between) N/A types triggers a fresh cap pre-check.
      if (this.isNaType(unavailableTypeId)) {
        this.runNaPrecheck();
      }
    });
  }

  onPostTimeoff(e) {
    const allowConflict = Utils.getCoreUser().company.allow_time_off_request_with_conflict
    if (EmployeeActions) {
      EmployeeActions.postTimeOff(
        this.state.startsAt,
        this.state.endsAt,
        this.state.notes,
        this.state.unavailableTypeId,
        allowConflict ? this.state.partial: this.state.partial || this.props.hideFullDay,
        this.state.requestError ? true : false
      );
    }
  }

  onTimeoffClick(e) {
    const that = this;
    that.resetPopover();

    const opening = !that.state.popOverActive;
    const unavailableTypeId = that.initialUnavailableType();

    that.setState({
      notes: '',
      popOverActive: opening,
      popTarget: Utils.isNotDefined(e) ? that.state.popTarget : e.target,
      unavailableTypeId,
      partial: that.initialPartialState(),
      declaringDepartmentId: that.initialDeclaringDept(),
      naAvailability: null,
      naError: '',
    }, () => {
      // Run the cap pre-check immediately if the opening type is an N/A type.
      if (opening && this.isNaType(unavailableTypeId)) {
        this.runNaPrecheck();
      }
    });
  }

  initialUnavailableType() {
    if (
      !Utils.isNotDefined(this.props.unavailableTypes)
      && this.props.unavailableTypes.length > 0
    ) {
      return this.props.unavailableTypes[0].id;
    }
    return undefined;
  }

  initialPartialState() {
    if (Utils.getCoreUser().company.time_off_mode === 'partial_day') {
      return true;
    }
    return false;
  }

  // ---- N/A helpers -----------------------------------------------------

  getDepartments() {
    const user = Utils.getCoreUser();
    return (user && user.departments) ? user.departments : [];
  }

  // Default declaring department: the "home" dept. No primary flag exists on
  // DepartmentUser today, so tie-break on the lowest department id.
  initialDeclaringDept() {
    const depts = this.getDepartments();
    if (depts.length === 0) return undefined;
    return depts
      .map(d => d.id)
      .reduce((min, id) => (id < min ? id : min), depts[0].id);
  }

  getTypeById(id) {
    if (Utils.isNotDefined(this.props.unavailableTypes)) return undefined;
    return this.props.unavailableTypes.find(t => t.id === id);
  }

  isNaType(id) {
    const type = this.getTypeById(id);
    return !!(type && type.na);
  }

  // True when the user has any N/A type available. N/A days are declared
  // authoritatively (no manager approval), so the generic entry button is
  // labelled "Add Time Off" rather than "Create Request" to avoid implying an
  // approval flow. Falls back to the request label when no N/A types exist.
  hasNaTypes() {
    if (Utils.isNotDefined(this.props.unavailableTypes)) return false;
    return this.props.unavailableTypes.some(t => t.na);
  }

  isNaSelected() {
    return this.isNaType(this.state.unavailableTypeId);
  }

  naDateStr() {
    return moment(this.props.selectedDate).format('YYYY-MM-DD');
  }

  // Published schedules are locked to *new* N/A declarations (the pre-check
  // returns `published`). Removal stays available after publication — see
  // Feature Spec §4.11 — so this gates submit only, never the remove action.
  naIsPublished() {
    const a = this.state.naAvailability;
    return !!(a && a.published);
  }

  runNaPrecheck() {
    const departmentId = this.state.declaringDepartmentId;
    if (Utils.isNotDefined(departmentId)) return;

    this.setState({ naAvailability: null });
    NaApi.getAvailability({ departmentId, date: this.naDateStr() }).then((result) => {
      if (result.ok && result.rows[0]) {
        this.setState({ naAvailability: result.rows[0] });
        return;
      }
      // Treat a failed pre-check as "unknown": leave submit disabled and
      // surface a generic message rather than allowing a blind declaration.
      this.setState({ naAvailability: { enabled: false }, naError: this.props.t('na.errors.generic') });
    });
  }

  onDeclaringDeptChange(e) {
    const declaringDepartmentId = parseInt(e.target.value);
    this.setState({ declaringDepartmentId, naError: '' }, () => this.runNaPrecheck());
  }

  // Whether the N/A "Submit" action should be disabled.
  naSubmitDisabled() {
    const a = this.state.naAvailability;
    return (
      this.naIsPublished()
      || Utils.isNotDefined(this.state.declaringDepartmentId)
      || !a
      || !a.enabled
      || a.full === true
      || a.period_full === true
    );
  }

  // Informational/blocking message shown under the N/A picker. Kept exhaustive
  // against naSubmitDisabled() so a disabled "Submit N/A Day" button always
  // explains itself: every condition that disables submit has a message here.
  // `isError: false` is used for non-blocking states (loading, availability
  // info) so they don't render as errors.
  naStatusMessage() {
    const a = this.state.naAvailability;
    // No declaring department resolved (e.g. the user isn't assigned to a
    // department), so the cap pre-check can't run and submit stays disabled.
    if (Utils.isNotDefined(this.state.declaringDepartmentId)) {
      return { text: this.props.t('na.staff.picker.no_declaring_dept'), isError: true };
    }
    // Pre-check still in flight after opening the picker or changing the date,
    // department or type. Submit is disabled until it resolves.
    if (!a) {
      return { text: this.props.t('na.staff.picker.checking'), isError: false };
    }
    if (a.published) {
      return { text: this.props.t('na.staff.picker.schedule_published'), isError: true };
    }
    if (!a.enabled) {
      return { text: this.props.t('na.staff.picker.dept_disabled'), isError: true };
    }
    if (a.full === true) {
      return { text: this.props.t('na.staff.picker.full'), isError: true };
    }
    // The per-scheduling-period cap (per employee, from FTE's period). Only
    // reported when the department has a period and the cap is limited.
    if (a.period_full === true) {
      return {
        text: this.props.t('na.staff.picker.period_full', { used: a.period_used, cap: a.per_block_cap }),
        isError: true,
      };
    }
    const lines = [];
    if (typeof a.per_day_cap === 'number') {
      lines.push(this.props.t('na.staff.picker.availability_info', {
        current_used: a.current_used,
        cap: a.per_day_cap,
      }));
    }
    if (typeof a.per_block_cap === 'number' && a.period_used !== null && a.period_used !== undefined) {
      lines.push(this.props.t('na.staff.picker.period_info', { used: a.period_used, cap: a.per_block_cap }));
    }
    if (lines.length) {
      return { text: lines.join(' · '), isError: false };
    }
    return null;
  }

  onDeclareNa(e) {
    if (this.naSubmitDisabled()) return;
    EmployeeActions.declareNa(
      this.state.unavailableTypeId,
      this.naDateStr(),
      this.state.declaringDepartmentId,
    );
  }

  onNaCreateSuccess() {
    // Calendar repaint is handled by ScheduleView's na:create:success listener.
    this._onClosePopover();
  }

  onNaCreateError(result) {
    const { code, reason } = NaApi.parseError(result);
    if (code === 'concurrent_conflict' && reason === 'schedule_published') {
      this.setState({ naError: this.props.t('na.staff.picker.schedule_published') });
      return;
    }
    this.setState({ naError: this.naErrorString(code) });
  }

  onRemoveNa(id) {
    confirmRemoveNa(this.props.t, () => {
      this.setState({ naListError: '' });
      EmployeeActions.removeNa(id);
    });
  }

  onNaRemoveSuccess(id) {
    // Calendar repaint is handled by ScheduleView's na:remove:success listener.
    this.setState({ naListError: '' });
  }

  onNaRemoveError(result, id) {
    const { code } = NaApi.parseError(result);
    // The row is already gone server-side (e.g. a coordinator overrode it in the
    // admin app). A self-remove of a soft-deleted row 404s; rather than strand a
    // ghost the user can't remove, repaint so the stale entry simply disappears.
    if (result.status === 404) {
      this.setState({ naListError: '' });
      UnavailablesStore.trigger('unavailables:na:remove:success', id);
      return;
    }
    this.setState({ naListError: this.naErrorString(code) });
  }

  naErrorString(code) {
    if (!code) return this.props.t('na.errors.generic');
    return this.props.t(`na.errors.${code}`, { defaultValue: this.props.t('na.errors.generic') });
  }

  // Returns a date/time picker based on
  // the company's time off settings
  datePicker(hideFullDayDatePicker) {
    let mode = Utils.getCoreUser().company.time_off_mode;
    // if there is a partial time off already,
    // hide the full day date pickers
    if (hideFullDayDatePicker) {
      // if conflicts are allowed show both full day and partial day.
      if(Utils.getCoreUser().company.allow_time_off_request_with_conflict) {
        mode = 'full_or_partial_day';
      } else {
        mode = 'partial_day';
      }
    }

    switch (mode) {
      case 'partial_day':
        return (
          <UnavailablesPartialDatePicker
            date={this.props.selectedDate}
            startsAt={this.state.startsAt}
            endsAt={this.state.endsAt}
            startsAtHandler={this.updateStateHandler.bind(this, 'startsAt')}
            endsAtHandler={this.updateStateHandler.bind(this, 'endsAt')}
            partialHandler={this.updateStateHandler.bind(this, 'partial')}
          />
        );
        break;
      case 'full_or_partial_day':
        return (
          <UnavailablesPartialFullDatePicker
            selectedDate={this.props.selectedDate}
            startsAt={this.state.startsAt}
            endsAt={this.state.endsAt}
            partial={this.state.partial}
            partialHandler={this.updateStateHandler.bind(this, 'partial')}
            startsAtHandler={this.updateStateHandler.bind(this, 'startsAt')}
            endsAtHandler={this.updateStateHandler.bind(this, 'endsAt')}
          />
        );
        break;
      default:
        // Default is Full Day Date Picker
        return (
          <UnavailablesFullDatePicker
            defaultDate={this.props.selectedDate}
            startsAtHandler={this.updateStateHandler.bind(this, 'startsAt')}
            endsAtHandler={this.updateStateHandler.bind(this, 'endsAt')}
          />
        );
    }
  }

  // Single full-day date display + declaring-department selector shown in place
  // of the range picker / notes when an N/A type is selected.
  renderNaForm() {
    const depts = this.getDepartments();
    const status = this.naStatusMessage();
    return (
      <div className="na-declare-form">
        <div className="na-selected-date">
          {Utils.formatLocaleDate(moment(this.props.selectedDate))}
        </div>
        {depts.length > 1 && (
          <div>
            <label htmlFor="na-declaring-department">
              {this.props.t('na.staff.picker.select_declaring_dept')}
            </label>
            <div className="styledSelect">
              <select
                id="na-declaring-department"
                onChange={this.onDeclaringDeptChange}
                value={this.state.declaringDepartmentId}
              >
                {depts.map(d => (
                  <option key={d.id} value={d.id}>{d.name}</option>
                ))}
              </select>
            </div>
          </div>
        )}
        {status && (
          <span className={`na-status ${status.isError ? 'na-error' : 'na-info'}`}>
            {status.text}
          </span>
        )}
      </div>
    );
  }

  render() {
    if (!Utils.isNotDefined(this.startPicker)) this.startPicker.setDate(this.props.selectedDate);
    if (!Utils.isNotDefined(this.endPicker)) this.endPicker.setDate(this.props.selectedDate);
    const today = moment(new Date().setHours(0, 0, 0, 0));

    let unavailableTypes = [];
    const shifts = [];
    let containsFullDayTimeOff = false;
    const isNa = this.isNaSelected();
    const selectedType = this.getTypeById(this.state.unavailableTypeId);

    if (this.props.unavailableTypes && this.props.unavailableTypes.length > 0) {
      unavailableTypes = this.props.unavailableTypes.map(type => (
        <option key={type.id} value={type.id}>
          {type.na ? `${type.name} (${this.props.t('na.staff.picker.na_badge')})` : type.name}
        </option>
      ));
    }

    // check if selectedDayData has a request
    if (this.props.shiftData && this.props.shiftData.length > 0) {
      const disabled = true;

      // Sort shifts by date first
      const sorted_shifts = this.props.shiftData.sort(
        (a, b) => new Date(a.starts_at) - new Date(b.starts_at),
      );

      for (let i = 0; i < sorted_shifts.length; i++) {
        if (!Utils.isNotDefined(sorted_shifts[i].id)) {
          const item = sorted_shifts[i];
          const row = describeUnavailable(item, this.props.t);

          if (!item.partial) {
            // If one of the unavailables is full-day time off
            // then we hide a bunch of buttons and date pickers
            containsFullDayTimeOff = true;
          }

          // N/A rows render with a self-removal action instead of cancel-request.
          shifts.push(
            <UnavailableSidebarItem
              key={`${item.id}-${row.displayedState}`}
              {...row}
              onRemoveNa={this.onRemoveNa}
            />,
          );
        }
      }
    }

    const classes = 'calendar-input time-off';

    // Hide everything if there are no unavailables:
    // 1. And Before today
    // 2. Or the create button is disabled
    // 3. Or the company has disabled time off requests
    const hideEverything = (
      shifts.length == 0 &&
      (moment(this.props.selectedDate).isBefore(today)
      || this.props.hideCreateButton
      || !Utils.getCoreUser().company.allow_time_off_requests)
    );

    if (hideEverything) {
      return <div />;
    }

    let timeOffCreateButton;
    if (
      moment(this.props.selectedDate).isBefore(today)
      || containsFullDayTimeOff
      || this.props.hideCreateButton
      || !Utils.getCoreUser().company.allow_time_off_requests
    ) {
      timeOffCreateButton = '';
    } else {
      const createLabel = this.hasNaTypes()
        ? this.props.t('na.staff.picker.add_time_off')
        : this.props.t('SidebarTimeOff.create_request');
      timeOffCreateButton = (
        <OfflineTooltip>
          <button
            className="calendar-input-button create-timeoff-button"
            onClick={this.onTimeoffClick}
            disabled={!Utils.isOnline()}
          >
            {createLabel}
          </button>
        </OfflineTooltip>
      );
    }

    const containsPartialTimeOff = !containsFullDayTimeOff && shifts.length > 0;

    return (
      <div>
        <div className={classes}>
          <span className="calendar-input-bullet timeoff-bullet">{this.props.t('SidebarTimeOff.time_off')}</span>
          {shifts.length > 0 && (
            <div className="data-list timeoff-requests">
              <ul>{shifts}</ul>
            </div>
          )}
          {this.state.naListError && (
            <span className="error-message na-list-error">{this.state.naListError}</span>
          )}
          {timeOffCreateButton}
        </div>
        <Popover
          onHide={e => this._onClosePopover(e)}
          position="right"
          className="popovertimeoff"
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
        >
          <h3>{isNa ? this.props.t('na.staff.picker.submit') : this.props.t('SidebarTimeOff.time_off_request')}</h3>
            <form id="timeoffFormContainer">
            <div>
            {!isNa && this.datePicker(containsPartialTimeOff || this.props.hideFullDay)}
            <div>
              <label htmlFor="timeoffTypes">{this.props.t('SidebarTimeOff.time_off_type')}</label>
              <div className="styledSelect">
                <select
                  id="timeoff-unavailable-type"
                  onChange={this.onUnavailTypeSelect}
                  value={this.state.unavailableTypeId}
                  >
                  {unavailableTypes}
                </select>
              </div>
            </div>
            {isNa && (
              <span
                className="na-type-swatch"
                style={selectedType && selectedType.colour ? { backgroundColor: selectedType.colour } : null}
              />
            )}
            {isNa ? this.renderNaForm() : (
              <div>
                <label htmlFor="timeoffNote">{this.props.t('SidebarTimeOff.note_optional')}</label>
                <textarea
                  id="timeoffNote"
                  name="timeoffNote"
                  placeholder=""
                  maxLength="254"
                  value={this.state.notes}
                  onChange={this.onTextAreaInput}
                  />
              </div>
            )}
              </div>
            {isNa
              ? <span className="na-error na-status">{this.state.naError}</span>
              : <span className="error-message" />}
          </form>
          <div className="btn-group pull--right">
            <button
              className="button button--inline timeoff-cancel-button"
              onClick={this.onTimeoffClick}
            >
              {this.props.t('SidebarTimeOff.close')}
            </button>
            {isNa ? (
              <OfflineTooltip>
                <button
                  className="button button--recommended button--inline na-declare-button"
                  onClick={this.onDeclareNa}
                  disabled={this.naSubmitDisabled() || !Utils.isOnline()}
                >
                  {this.props.t('na.staff.picker.submit')}
                </button>
              </OfflineTooltip>
            ) : (
              <OfflineTooltip>
                <button
                  className="button button--recommended button--inline timeoff-post-button"
                  onClick={this.onPostTimeoff}
                  disabled={!Utils.isOnline()}
                >
                  {this.props.t('SidebarTimeOff.send_request')}
                </button>
              </OfflineTooltip>
            )}
          </div>
        </Popover>
      </div>
    );
  }
}

export default translate()(SidebarTimeOff);
